export const styles = {
    dialogContainer: {
        width: "70%",
        height: "95%",
        maxWidth: "none",
    },
    dialogTitle: {
        marginLeft: "0 !important",
        marginRight: "0 !important",
        padding: "24px 24px 20px",
        borderBottom: "1px solid rgb(225, 225, 225)",
    },
};
